<div>
    <button mat-raised-button (click)="createConsoleLogJob()">Create Console Log Job</button>
    <button mat-raised-button (click)="createEmailJob()">Create Email Job</button>
    <button mat-raised-button (click)="createSMSJob()">Create SMS Job</button>
    <button mat-raised-button (click)="invoiceReminderJob()">Create Invoice Reminder Job</button>
    <button mat-raised-button (click)="bankSyncJob()">Bank Sync Job</button>
</div>

<!-- <div *ngFor="let job of jobs">
    {{job.date.start | date:"dd-MM-yy h:m"}} - {{job.job}} - {{job.state}} - <button (click)="deleteJob(job)">Delete Job</button>
</div> -->